module.exports = __webpack_public_path__ + "b366e28023ce89bc2a96276b97d77fb3.png";